import React from 'react';
import { Avatar } from 'antd';
import { clsx } from 'clsx';

export const UserAvatar = ({
  initials,
  textAsInitials,
  size = 40,
  textColor,
  backgroundColor,
  onClick,
  style,
  ...props
}: {
  initials?: string;
  textAsInitials?: string;
  size?: number;
  textColor?: string;
  backgroundColor?: string;
  onClick?: () => void;
  style?: { [key: string]: unknown };
}) => (
  <>
    <div
      onClick={onClick}
      className={clsx('UserAvatar', !!onClick && 'click-enabled')}
    >
      <Avatar
        shape="circle"
        size={size}
        className="avatar"
        style={{
          ...style,
          backgroundColor: backgroundColor,
          color: textColor,
          fontSize: `${size / 2.5}px`,
        }}
        {...props}
      >
        {initials || extractInitials(textAsInitials || '')}
      </Avatar>
    </div>
    <style jsx>{`
      .UserAvatar {
        display: inline-block;
        cursor: default;
        text-transform: lowercase;
      }
      .UserAvatar.click-enabled {
        cursor: pointer;
      }
    `}</style>
  </>
);

function extractInitials(text: string) {
  return text
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}
